module.exports = __webpack_public_path__ + "static/media/smile-nerd.30553f27.svg";